import { render, staticRenderFns } from "./PostDate.vue?vue&type=template&id=45b348f9&"
import script from "./PostDate.vue?vue&type=script&lang=js&"
export * from "./PostDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports